// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"77":"99a3970d","209":"99a3970d","264":"58c7f111","352":"99a3970d","377":"99a3970d","417":"99a3970d","579":"6aa1c55b","929":"99a3970d"}[chunkId] + ".chunk.css";
};